import { HANDLEBAR_TOKEN_DATA_ATTR, TOKEN_HTML_TAG } from '../constants';
import { createHTML } from './createHTML';

export const createHandlebarsToken = (displayText: string, handlebars: string, iconSrc: string) => {
  const icon = createHTML('img', { src: iconSrc });
  const token = createHTML(
    TOKEN_HTML_TAG,
    { contenteditable: 'false', [HANDLEBAR_TOKEN_DATA_ATTR]: handlebars },
    [icon, document.createTextNode(displayText)],
  );
  return token.outerHTML;
};
